export default __webpack_public_path__ + "static/media/E-WEB-Goal-12.d3360baf.png";